import { render, staticRenderFns } from "./fallibleSeven.vue?vue&type=template&id=4e6bf8e6&scoped=true"
import script from "./fallibleSeven.vue?vue&type=script&lang=js"
export * from "./fallibleSeven.vue?vue&type=script&lang=js"
import style0 from "./fallibleSeven.vue?vue&type=style&index=0&id=4e6bf8e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6bf8e6",
  null
  
)

export default component.exports